import { render, staticRenderFns } from "./site-development-required.vue?vue&type=template&id=94c4ec22"
import script from "./site-development-required.vue?vue&type=script&lang=js"
export * from "./site-development-required.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports